module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "chap1",
      "src": "images/chap1.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("ALL THE FEELS")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "tortue",
      "src": "images/tortue.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_c('b', [_vm._v("“CHRISTINE, HOW ARE YOU FEELING?”")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For years, this question has been difficult for me to answer. The more accurate question for a Four might be, “What "), _c('i', [_vm._v("aren’t")]), _vm._v(" you feeling?”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As a Four, I store a complex universe of emotions in my inner being. When asked, “How are you doing?” I can grab my prevailing emotion and tell you how I’m doing from that emotion’s point of view (joy, elation, sadness, grief, confusion —you name it!), but at any given time I live and breathe a kaleidoscope of living, feeling, conflicting emotions.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Many times Fours are labeled as “emotionally intense” or “too much,” but for us it is just simply how we are. We’re comfortable with liminality and in-between spaces. When Fours are healthy, our emotional state doesn’t occupy anyone else’s experience—instead, the multitude of emotions we carry gives us the ability to carry conflicting or contradictory emotions for others. Fours have an incredible capacity to hold space for others in paradoxical and transcendental moments. We are often invited into sacred moments (for example, the death of a loved one, the birth of a "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("baby, transitional seasons in career, relational conflict, and so on) to help others steward these deep emotions fully.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In Luke 7:36-50, an unnamed woman comes to find Jesus. Jesus is dining at a Pharisee’s home when the woman falls to the floor, begins to cry, and kisses his feet. She then pulls out a jar of expensive perfume to pour onto Jesus’ feet, anointing and worshiping him in uninhibited adoration. While the Pharisees and disciples treat her with disdain because of her reputation and actions, Jesus responds with affection and esteem for her.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I love this story. Maybe it’s because I like to think this unnamed woman was a Four—her creative expression in love, her unending desire to be known, her emotional rawness and intensity, and her authentic, unique way of showing up to Jesus. People misunderstood, devalued, and questioned her. The Gospel writer does not even give her name. But Jesus knew her. He dignified her and received her worship, heralding her as a faithful example for the disciples to follow.")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-001"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("Can you identify with the woman in this story? In what ways have you been misunderstood, devalued, or questioned by others? ")])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "response"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("Bring your weariness and exhaustion to Jesus, trusting that you can be uninhibited and unfiltered in his presence. Take some time to hear Jesus saying to you as he said to the woman, “Your faith has saved you; go in peace.”")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 72
// module chunks = 0